<template>
  <div class="mt-3 container__employee">
    <b-card class="no-border animated employee__card align__center" bg-variant="light">
      <b-img rounded="circle" width="75" height="75" src="http://qualiscare.com/wp-content/uploads/2017/08/default-user.png"/>
      <p class="card-text">
        <p class="h4 text-dark">{{ detailedInfo.name }}</p>
        <p class="h6 text-secondary">{{ detailedInfo.type }}</p>
      </p>
      <div class="list-group employee__navigations mx-auto">
        <b-nav>
          <b-nav-item @click="section = ''" :active="section == ''">Detail</b-nav-item>
          <b-nav-item @click="section = 'activity'" :active="section == 'activity'">Activity</b-nav-item>
        </b-nav>
      </div>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
  import dateMixin from '@/mixins/date';

  export default {
    name: 'employee_detail',
    mixins: [dateMixin],
    data() {
      const routes = this.$route.fullPath.split('/');
      return {
        section: routes[4] || '',
        loaded: false,
      };
    },
    created() {
      const { employeeId } = this.$route.params;
      this.$store.commit('employees/SET_DETAIL_ID', employeeId);
      this.$store.commit('SET_BREADCRUMB_ITEMS', [
        { to: '', name: 'Home' },
        { to: 'employees', name: 'Employees' },
        { to: employeeId, name: 'Detail' },
      ]);
    },
    computed: {
      detailedInfo() {
        return this.$store.getters['employees/get_detail_data'];
      },
    },
    watch: {
      section(newSection) {
        const { employeeId } = this.$route.params;
        this.$router.push(`/employees/${employeeId}/${newSection}`);
      },
    },
  };
</script>

<style scoped lang="sass">
  .align__center
    text-align: center

  .employee__navigations
    border: none
    width: 318px

  .card-body
    padding-bottom: 0px !important

  .nav-link:hover
    border-bottom: 2px #BDBDBD solid
</style>



// WEBPACK FOOTER //
// src/views/pages/employee/Detail.vue